export default __webpack_public_path__ + "static/media/ossscreen2.8b2ea775.png";